module.exports = __webpack_public_path__ + "img/image_thumbnail_error.560ff030.png";